export const TRACE_ID_NAME = 'x-housing-trace-id';
export const MATURITY_YEARS = 30;
export const MINIMUM_LOAN_VALUE = 10000;
export const CURRENT_INTEREST = 3.4;
export const MAXIMUM_INCOME_AMOUNT = 99_999;
export const STEP = 5000;
